export default __webpack_public_path__ + "media/images/icons/logo-multicolor-98c0376776f13bae85ea34d6f37e3f47.svg";